<script lang="ts">
  import GridContainer from "$lib/molecules/GridContainer.svelte";
  import GridItem from "$lib/atoms/GridItem.svelte";
  import Footer from "$lib/views/Footer.svelte";

  export let data: any;

  const socials = data.globals.story.content.socials;
  const footerBottomLinks = data.globals.story.content.footerBottomLinks;
</script>

<div class="page">
  <div class="section hero yellow">
    <div class="movable">
      <div class="section-inner">
        <div class="wrapper">
          <GridContainer alignItems="center" justifyContent="space-between">
            <GridItem alignSelf="end" col={12} colMd={4}>
              <div class="info">
                <h6 class="title type:h6-medium">
                  Hmm. This page doesn’t exist.
                </h6>
                <p class="text type:body-medium">
                  We’re usually pretty good at getting from place to place.
                </p>
              </div>
            </GridItem>
            <GridItem col={12} colMd={3} offset={0} offsetMd={3}>
              <a class="type:body-medium" href="/">Go to Homepage</a>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  </div>
  <Footer categories={[]} {socials} {footerBottomLinks} />
</div>

<style lang="scss">
  .wrapper {
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 calc(var(--grid-padding) - 20px);
    z-index: 1;
    overflow: hidden;
    background-image: url("/images/404.webp");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 50vh;

    @include breakpoint("small") {
      background-size: 90vh;
    }

    .info {
      max-width: 280px;
      padding-bottom: fluid(16px, 16px);
      @include breakpoint("small") {
        padding-bottom: 0;
        max-width: 100%;
      }

      .title {
        padding-bottom: fluid(8px, 8px);
      }

      .text {
        color: rgb(var(--color-black));
      }
    }

    a {
      color: rgb(var(--color-black));

      &:visited {
        color: rgb(var(--color-black));
      }
    }
  }

  .section-inner {
    border-radius: var(--border-radius-section);
    height: calc(100vh - (fluid(88px, 88px)));
  }

  .hero {
    padding-top: 0;
    position: relative;

    &.yellow .section-inner {
      background: rgb(var(--color-yellow-primary));
    }
  }
</style>
